import { DrilldownPanelType } from 'features/drilldown/types'

/**
 * Enable Impl-specific panels for specific organizations.
 *
 * This is used to enable panels that are not globally available, but are
 * enabled for specific organizations.
 *
 */
export const PANEL_FLAGS_BY_ORG: Record<
  string,
  ReadonlyArray<DrilldownPanelType>
> = {
  'falcon-6f06dc': [
    'rbiMatrix',
    'niiLibraResultsByZonePanel',
    'niiLibraResultsPanel',
    'niiRoiPanel',
    'ffsResultTable',
  ],
  'osprey-41b322': ['rbiMatrix', 'ffsResultTable'],
  'atlantic-enterprises': [],
}
